// extracted by mini-css-extract-plugin
export default {"campaignCardContainer":"usTV6EU","headline":"oCif6r8","list":"l9FdaOF","item":"_dfX3qi","single-card":"qIbrTip","ratio-16-9":"qL8Qyvw","ratio-3-4":"QxavkaV","ratio-1-1":"ueYnokV"};